module.exports = __webpack_public_path__ + "img/image_part_009.674a32bd.jpg";